var Interface = require('../core');
var Enumeration = require('utility-js-enumeration').default;
var _ = require('lodash');

Interface.type('html', {
  defaultValue: '',
  isOfType: function isOfTypeHMTL(val) {
    return this.discoverType(val) === 'string';
  }
})
  .type('enum', {
    convertToSync: function (sourceValue, requirement) {
      var enumeration = requirement.typeDef.isEnumType
        ? requirement.typeDef
        : Enumeration.__registered__[requirement.typeDef];

      if (!enumeration) {
        return undefined;
      }

      // TODO make this only happen once, it will because it will not be a string afterwards, but it is stupid
      if (_.isString(requirement.defaultValue)) {
        requirement.defaultValue = enumeration.get(requirement.defaultValue);
      }

      return !sourceValue || !enumeration ? undefined : enumeration.get(sourceValue);
    },
    isOfType: function verifyTypeEnumeration(val) {
      return val && val.isEnum;
    },
    convertToSource: function enum_convertToSource(sourceProp) {
      return sourceProp.key;
    }
  })
  .type('ordinal', {
    convertToSync: function (sourceValue, requirement) {
      var enumeration = requirement.typeDef.isEnumType
        ? requirement.typeDef
        : Enumeration.__registered__[requirement.typeDef];

      if (sourceValue && sourceValue.ordinal) {
        sourceValue = sourceValue.ordinal;
      }

      // TODO make this only happen once, it will because it will not be a string afterwards, but it is stupid
      if (_.isString(requirement.defaultValue)) {
        requirement.defaultValue = enumeration.get(requirement.defaultValue);
      }

      return sourceValue === undefined || enumeration === undefined ? undefined : enumeration.ordinal(sourceValue);
    },
    isOfType: function verifyTypeEnumeration(val) {
      return val && val.isEnum;
    },
    convertToSource: function convertToSource(sourceProp) {
      return sourceProp.ordinal;
    }
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/types/types.js